export default "__VITE_ASSET__70154acb__"